import { render, staticRenderFns } from "./NotFound.vue?vue&type=template&id=759c6923&scoped=true"
var script = {}
import style0 from "./NotFound.vue?vue&type=style&index=0&id=759c6923&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "759c6923",
  null
  
)

export default component.exports